<template>
  <modal name="modal-add-template" height="auto" :width="560"
         :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>ADD EMAIL TEMPLATE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <template v-if="postData">
      <form method="post" action="" ref="form" @submit.prevent="doCreate">
        <div class="form-group">
          <label for="name">Name <span class="text-danger">*</span></label>
          <input type="text" name="name" id="name" ref="inputName"
                 :class="{'form-control': true, 'is-invalid': errors.has('name')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.name">
          <div class="invalid-feedback">{{ errors.first('name') }}</div>
        </div>
        <div class="form-group">
          <label for="name">Subject <span class="text-danger">*</span></label>
          <input type="text" name="email_subject" id="email_subject"
                 :class="{'form-control': true, 'is-invalid': errors.has('email_subject')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.email_subject">
          <div class="invalid-feedback">{{ errors.first('email_subject') }}</div>
        </div>
        <div class="form-group">
          <label for="name">From Name <span class="text-danger">*</span></label>
          <input type="text" name="from_name" id="from_name"
                 :class="{'form-control': true, 'is-invalid': errors.has('from_name')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.from_name">
          <div class="invalid-feedback">{{ errors.first('from_name') }}</div>
        </div>
        <div class="form-group">
          <label for="name">From Email <span class="text-danger">*</span></label>
          <input type="text" name="from_email" id="from_email"
                 :class="{'form-control': true, 'is-invalid': errors.has('from_email')}"
                 v-validate.disable="{ required: true }"
                 v-model="postData.from_email">
          <div class="invalid-feedback">{{ errors.first('from_email') }}</div>
        </div>
        <div class="pt-2 btns btns-2">
          <beat-loader v-if="state == 'saving'"></beat-loader>
          <template v-else>
            <button type="submit" class="btn btn-outline-black mr-2">Submit</button>
            <button type="button" class="btn btn-outline-gray" @click="closeModal">Cancel</button>
          </template>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import BeatLoader from 'vue-spinner/src/BeatLoader'

  export default {
    components: {
      BeatLoader,
    },
    data () {
      return {
        state: '',
        postData: false,
      }
    },
    props: ['value'],
    watch: {
      value ( newVal ) {
        let self = this;
        if ( newVal ) {
          self.$modal.show('modal-add-template', {});
          setTimeout(() => {
            self.$refs.inputName.focus();
          }, 200);
        }
      }
    },
    mounted () {
      this.init();
    },
    methods: {
      init () {
        let self = this;
        self.resetForm();
      },
      resetForm () {
        let self = this;
        self.postData = {
          name: '',
          email_subject: '',
          from_name: 'Kyzen',
          from_email: 'noreply@kyzen.com.au'
        };
      },
      closeModal () {
        this.$modal.hide('modal-add-template');
      },
      doCreate ( ) {
        let self = this;
        if (self.state == 'saving') {
          return;
        }

        self.$validator.validateAll()
          .then(ok => {
            if ( ok ) {
              self.state = 'saving';
              self.$store.dispatch('ADD_TEMPLATE', self.postData)
                .then(template => {
                  self.state = '';
                  self.$notify({
                    type: 'success',
                    text: 'Template "<strong>' + template.name + '</strong>" added successfully.'
                  });
                  self.resetForm();
                  self.$emit('added', template);
                  self.closeModal();
                })
                .catch((error) => {
                  window.console.log(error);
                  self.state = '';
                });
            }
          });
      }
    }
  }
</script>
